<div *ngIf="task; else no_tasks">
    <h2 *ngIf="task.isProcess;else Zoning_code_statistic" mat-dialog-title
        ngClass="{{task.isStep ? 'modal-step-header' : ''}}">{{ task.isStep ? 'Step ' + task.stepIndex + ':
        ' : ''}}{{ task.typeStr }}</h2>
    <h4>{{task.hasSteps ? 'Summary:' : 'Statistic:'}}</h4>

    <div class="mat-typography">
        <app-process-status-row [process]="task"></app-process-status-row>
        <app-process-statistic-section [process]="task"></app-process-statistic-section>
        <app-process-stats-by-status-section [process]="task" [smallTitle]="true"></app-process-stats-by-status-section>

        <div *ngIf="task['syncSolrData'] !== undefined" class="mat-typography" style="margin-top: 15px;">
            <p>Send data to Solr: {{task?.syncSolrData?'Yes':'No'}}
            </p>
        </div>

        <div *ngIf="showSaveRawIds" class="mat-typography">
            <p>Save PR Ids for investigation: {{task?.saveRawIds?'Yes':'No'}}
            </p>
        </div>

        <div *ngIf="task['recalculateAllPRs'] !== undefined" class="mat-typography">
            <p>Recalculate all listed Property Records: {{task?.recalculateAllPRs?'Yes':'No'}}
            </p>
        </div>
        <div *ngIf="task['prsWithAddedZCConflictsCount'] !== undefined" class="mat-typography"
            [ngClass]="{'red-text': task.prsWithAddedZCConflictsCount > 0}">
            <p>PRs count with multiple new markets: {{task?.prsWithAddedZCConflictsCount}}
            </p>
        </div>
        <div *ngIf="task['prsGroupIdsWithAddedZCConflicts'] !== undefined" class="mat-typography"
            [ngClass]="{'red-text': task.prsGroupIdsWithAddedZCConflicts.length > 0}">
            <p>PRs with multiple new markets: {{task?.prsGroupIdsWithAddedZCConflicts.join(', ')}}
            </p>
        </div>

        <app-data-source-category-view *ngIf="showDataSourceCategories"
            [dataSourceCategories]="task.dataSourceCategories"></app-data-source-category-view>

        <p *ngIf="task.messages.length" style="margin-bottom: 0px">Messages:</p>
        <div *ngIf="task.messages.length" class="scrollableMessages">
            <mat-list>
                <ng-container *ngFor="let message of task['messages']">
                    <p>{{message}}</p>
                </ng-container>
            </mat-list>
        </div>

    </div>

    <div *ngIf="task?.solrGroupIdsStatistic">
        <h4 class="md-subhead">Synchronization with Solr - <app-solr-operations-status
                [data]="task?.solrGroupIdsStatistic"></app-solr-operations-status></h4>
        <app-solr-group-ids-data-statistic [data]="task?.solrGroupIdsStatistic">
        </app-solr-group-ids-data-statistic>
    </div>
</div>

<ng-template #no_tasks>
    <h2>Tasks are not found</h2>
</ng-template>

<ng-template #Zoning_code_statistic>
    <h2>Zoning code statistic</h2>
</ng-template>